import * as React from 'react';

import * as styles from './commentSection.css';
import { CommentFormContainer } from '../../containers/CommentFormContainer';
import { CommentShow } from '../CommentShow';

export interface ICommentSectionProps {
  editable?: boolean; //TODO: вернуть обязательное значение, когда будет логика
  comment?: string | null;
  entityId: number;
  isFetching: boolean;
  name: string;
}

export const CommentSection = ({ editable, comment, entityId, isFetching }: ICommentSectionProps) => {
  if (editable) {
    return (
      <div className={styles.comment_section_container}>
        <CommentFormContainer comment={comment} entityId={entityId} isFetching={isFetching} />
      </div>
    );
  }

  if (comment) {
    return (
      <div className={styles.comment_section_container}>
        <div className={styles.comment_section}>
          <CommentShow comment={comment} entityId={entityId} />
        </div>
      </div>
    );
  }

  return null;
};
